import React from "react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0d0d0d] text-[#8a8a8a] py-6 border-t border-[#1f1f1f]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div
          data-testid="footer-copyright"
          className="font-mono-indie text-[11px] tracking-[0.2em]"
        >
          © {new Date().getFullYear()} TYRELLE SOUND — ALL RIGHTS RESERVED
        </div>
        <div className="font-mono-indie text-[11px] tracking-[0.2em] text-[#5a5a5a]">
          POST AUDIO FOR INDIE FILM
        </div>
      </div>
    </footer>
  );
};

export default Footer;
